import React, {
  Component
} from 'react';
import {
  connect
} from 'react-redux';
import {
  push,
  replace
} from 'react-router-redux';
import {
  Container,
  Header,
  Icon,
  Menu,
  Segment
} from 'semantic-ui-react';
import {
  Link
} from 'react-router-dom';
import {
  Route
} from 'react-router-dom';
import feathersConnect from './../../../providers/feathersConnect';
import UsersView from './UsersView';

class SystemView extends Component {

  constructor (props) {
    super(props);
  }

  componentDidMount () {

  }

  static mapStateToProps (state) {
    return {
      routing: state.routing,
      authentication: state.authentication.toJS({ deep: true })
    };
  }

  static mapDispatchToProps (dispatch) {
    return {
      navigate: (path) => {
        dispatch(push(path));
      }
    };
  }

  render () {
    return (
      <Container style={{ padding: 16 }}>
        <Header as="h2">
          <Icon name="settings" />
          <Header.Content>
            Configuracion del Sistema
            <Header.Subheader>
              Administrar Usuarios/Roles/Permisos
            </Header.Subheader>
          </Header.Content>
        </Header>
        <Menu attached="top" tabular>
          <Menu.Item
            as={Link} to="/sistema/usuarios"
            active={!!window.location.pathname.match(new RegExp(`^/sistema/usuarios/?$`))}
            name="usuarios" />
        </Menu>
        <Route path={`${this.props.match.url}/usuarios`} render={() => {
          return (
            <Segment attached="bottom">
              <UsersView />
            </Segment>
          );
        }} />
      </Container>
    );
  }
}

export default feathersConnect(
  connect(
    SystemView.mapStateToProps,
    SystemView.mapDispatchToProps
  )(SystemView)
);



// WEBPACK FOOTER //
// ./client/components/pages/system/SystemView.js